export default __webpack_public_path__ + "static/media/fof-benchmarking-study.9ef39015.pdf";